import React, { useEffect } from 'react';
import saveToMongoFunction from "../utils/saveToMongoFunction";
import SwitchModal from './Test/WindowSwitch/SwitchModal';
import { msSinceFullscreenRequest } from '../utils/fullscreen';

// A blur this soon after we asked for full screen is checked again once it has settled.
const FULLSCREEN_SETTLE_MS = 2000;

const WindowFocusHandler = (props) => {
  const { showModel, setModelShow, setWindowSwitch, windowSwitchCount, faceNotFoundCount, examId, examDetail, testData, setTestData, closeModal, onSubmit, result, showResult, showscore, updateFlag, _setWebProcteringZero, _webProctoring, setIsWindowSwitched } = props;
  const [onReload, setOnReload] = React.useState(true)
  // True from the moment a switch is counted until the candidate is back, so one leave that fires
  // both blur and visibilitychange (desktop tab switch) is counted once.
  const awayRef = React.useRef(false);
  // A refresh or close also hides the page; that is not a switch.
  const unloadingRef = React.useRef(false);
  // debugger;
  // User has switched back to the tab
  const onFocus = () => {
    // console.log('Tab is in focus');
    //  setModelShow(true);
    awayRef.current = false;
    setIsWindowSwitched(false)
  };
  // User has switched away from the tab (AKA tab is hidden)
  // Counts only leaving the test window (another tab or app). The window also blurs when focus
  // moves into an iframe on the page (e.g. the descriptive-answer editor); the page still has
  // focus then, so that is not a switch. Our own popups never take focus off the page.
  const onBlur = () => {
    setTimeout(() => {
      if (document.hasFocus()) return;
      countSwitch();
    }, Math.max(0, FULLSCREEN_SETTLE_MS - msSinceFullscreenRequest()));
  };
  // Phones and tablets often don't blur the window when the candidate opens another app or tab;
  // the page is only hidden. Hidden = left the test.
  const onVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      if (!unloadingRef.current) countSwitch();
    }
    else if (document.hasFocus()) onFocus();
  };

  const countSwitch = () => {
    if (awayRef.current) return;
    awayRef.current = true;
    if (onReload === true || onReload === undefined) {
      // Kept on examDetail[0] until a save takes it off the allowance (saveToMongoFunction.js);
      // windowSwitchCount mirrors it for the warning text and the abort check in Test.jsx.
      const pending = Number(examDetail[0].pendingWindowSwitches) || 0;
      if (examDetail[0].webproctoringcount >= pending) {
        examDetail[0].pendingWindowSwitches = pending + 1;
        setWindowSwitch(pending + 1);
      }

      if ((examDetail[0].webproctoringcount - windowSwitchCount) < 0) {
        setModelShow(true);
        setIsWindowSwitched(true)
        // setModelShow(false);
      } else {
        setModelShow(true);
        setIsWindowSwitched(true)
      }

    }
    else {
      // setWindowSwitch(windowSwitchCount +1);
      setModelShow(false)
      setIsWindowSwitched(false)
      setOnReload()
    }
  };

  const onBeforeUnload = (event) => {
    // setWindowSwitch(windowSwitchCount - 1)
    unloadingRef.current = true;
    setOnReload(false)
    setModelShow(false);
    setIsWindowSwitched(false)
    if (event.currentTarget) {
      if (examDetail[0].webproctoringcount - windowSwitchCount >= 0) {
        saveToMongoFunction(examId, examDetail, setWindowSwitch, setTestData, windowSwitchCount, faceNotFoundCount, testData)
      }
      //setWindowSwitch(windowSwitchCount +1)
      setOnReload(false); //
    }
  }

  useEffect(() => {
    // One named handler per render, removed on cleanup. It used to be added as a new arrow
    // function every render and "removed" with a different one, so every render's copy stayed:
    // on refresh each one saved the test with the switch count of its own render - the oldest
    // with 0 switches - and one of those could win, giving the switches back.
    const beforeUnload = (e) => onBeforeUnload(e);
    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);
    window.addEventListener('beforeunload', beforeUnload);
    document.addEventListener('visibilitychange', onVisibilityChange);
    // Specify how to clean up after this effect:
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
      window.removeEventListener('beforeunload', beforeUnload);
    };
  });
  return (
    <>{
      // (examDetail[0].webproctoringcount - windowSwitchCount) < 0
      // ?
      // onSubmit('111')
      // :
      showModel
        ?
        //onReload === false || onReload === undefined ?

        examDetail[0].webproctoringcount >= 0 //&& !examDetail[0].navflag
          ?
          <SwitchModal updateFlag={updateFlag} result={result} showResult={showResult} showscore={showscore} showModel={showModel} setModelShow={setModelShow} setOnReload={setOnReload} setIsWindowSwitched={setIsWindowSwitched}
            message={(examDetail[0].webproctoringcount - windowSwitchCount) < 0
              ?
              `<div>We are Sorry to inform you that your ${examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "survey" : "test"} has been terminated.</div>`
              :
              (examDetail[0].webproctoringcount - windowSwitchCount) === 0
                ?
                `<div>You cannot switch to another window while giving this ${examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "survey" : "test"}. If you attempt the same <u style={{color:'red'}}><b>ONCE MORE</b></u>, your ${examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "survey" : "test"} will be terminated immediately.<br/><br/>Thanking you, <br/>Support, AssessHub.</div>`
                :
                `<div>You cannot switch to another window while giving this ${examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "survey" : "test"}. If you attempt the same, your ${examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "survey" : "test"} will be terminated immediately.<br/><br/>Thanking you, <br/>Support, AssessHub.</div>`
            }
            header={(examDetail[0].webproctoringcount - windowSwitchCount) < 0
              ?
              'Violation of Rule !!!'
              :
              (examDetail[0].webproctoringcount - windowSwitchCount) === 0
                ?
                'LAST WARNING !!!'
                :
                'WARNING !!!'
            } closeModal={closeModal} onSubmit={onSubmit} setWindowSwitch={setWindowSwitch} />

          :
          <></>
        :
        <></>
      // :
      // <></>
    }
    </>
  );
};
export default WindowFocusHandler;